export default __webpack_public_path__ + "static/media/hht1_ep12_minisitcom_03.0aee1e70.png";